import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipPricingDiscountsCreateControllerModule } from './controllers/MembershipPricingDiscountsCreateController';

export const MembershipPricingDiscountsCreateView = angular
  .module('acme.view.application.membership.pricing.discounts.create', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    MembershipPricingDiscountsCreateControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.membership.pricing.discounts.create',
      url: '/create',
      views: {
        'subview-main@application': {
          controller: 'MembershipPricingDiscountsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/pricing/discounts/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'New membership coupon discount',
        /** Secure With Permissions **/
        permissions: ['MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_CREATE'],
      },
    });

    $stateProvider.state({
      name: 'application.membership.pricing.discounts.edit',
      url: '/:id/edit',
      views: {
        'subview-main@application': {
          controller: 'MembershipPricingDiscountsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/pricing/discounts/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit membership coupon discount',
        /** Secure With Permissions **/
        permissions: ['MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_UPDATE'],
      },
    });
  }).name;
